import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Profile, UserState } from "@/types/authentication";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "@/utils/localStorageHelper";
import { localStorageKey } from "@/enums/localStorageKey";

const accessToken = getLocalStorageItem(localStorageKey.ACCESS_TOKEN) as string;
const refreshToken = getLocalStorageItem(
  localStorageKey.REFRESH_TOKEN,
) as string;

const initialState: UserState = {
  profile: getLocalStorageItem(localStorageKey.ACCESS_TOKEN)
    ? {
        accessToken,
        refreshToken,
      }
    : null,
};

export const authSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Profile>) => {
      state.profile = {
        ...action.payload,
      };

      setLocalStorageItem(
        localStorageKey.ACCESS_TOKEN,
        action.payload.accessToken,
      );
      setLocalStorageItem(
        localStorageKey.REFRESH_TOKEN,
        action.payload.refreshToken,
      );
    },

    logout: (state: UserState) => {
      state.profile = null;
      localStorage.clear()
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
